import api from "../../utils/api";

export const adminGet = async (path, params = {}) => (await api.get(`/super-admin${path}`, { params })).data;

export const adminMutation = async (method, path, body = {}) => {
  const key = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return (await api.request({
    method,
    url: `/super-admin${path}`,
    data: body,
    headers: { "Idempotency-Key": key, "X-Correlation-Id": key },
  })).data;
};

export const adminDownload = async (path, filename) => {
  const response = await api.get(`/super-admin${path}`, { responseType: "blob" });
  const href = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
};

export const errorMessage = (failure) => {
  const detail = failure?.response?.data?.error;
  const message = detail?.message || failure?.message || "The request could not be completed.";
  return detail?.requestId ? `${message} Request ${detail.requestId}.` : message;
};
